import React from 'react';
import './sass/subscriptions.scss';

function Subscriptions({
  fulfillmentDetails,
  shippingDetails,
  selectedOption
}) {
	return (
		<div className="subscription__wrapper">
			{
				fulfillmentDetails.subscribeAndSaveEligible &&
	        	shippingDetails.enabled && 
	        	!fulfillmentDetails.sthNotAvailable && 
	        	!fulfillmentDetails.isOSSAtOnline &&
				selectedOption !== "STH" && (
				<div className="subscribe-and-save_disabled">
				  <div>
				      <div className="radio-btn__content-wrapper">
				        <input disabled 
				        	type="radio" 
				        	className="radio-btn__input"
				        	id="subscribe-and-save-options__opt-in_disabled"
				        />
				        <label 
				        	className="radio-btn__label" 
				        	for="subscribe-and-save-options__opt-in_disabled">
				          <span className="radio-btn"></span>
				          <span className="subscribe-and-save-options__title_disabled">
				          	Subscribe and Get 5% off
				          </span>
				        </label>
				      </div>
				  </div>
				  <div id="subscribe-and-save-message_disabled">
				    <div className="subscribe-and-save-message_disabled">
				      <span>Available for Ship to Home only. </span>
				    </div>
				  </div>
				</div>
			)}
		</div>
	);
}

export default Subscriptions;
